var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    staticClass: "text-caption",
    attrs: {
      value: _vm.value,
      label: _vm.label,
      "prepend-inner-icon": _vm.icon,
      items: _vm.items,
      loading: _vm.loading,
      "search-input": _vm.search,
      "item-text": _vm.itemText,
      "menu-props": _vm.menuProps,
      "no-filter": "",
      "return-object": "",
      "hide-details": "",
      clearable: "",
      dense: "",
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event
      },
      "update:search-input": function ($event) {
        _vm.search = $event
      },
      change: _vm.onSelect,
      "click:clear": _vm.onClear,
      click: function ($event) {
        $event.stopPropagation()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _c(
              "v-list-item-content",
              [
                _c("v-list-item-title", [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(item.locode)),
                  ]),
                  _vm._v(" · " + _vm._s(item.countryName) + " "),
                ]),
                _c("v-list-item-subtitle", [_vm._v(_vm._s(item.countryId))]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }